import { $ } from "./elemental";
const timeoutMS = 2000;
const waitForSelector = async (elementSelector) => {
  const started = new Date().getTime();
  while (new Date().getTime() - started < timeoutMS) {
    if (typeof elementSelector === "string") {
      const found = $(elementSelector);
      if (found.get().length) return found.get();
    } else if (elementSelector) {
      return elementSelector;
    }
  }
  return false;
};
export { waitForSelector };
